import { useMemo } from 'react'

// Components
import { AccountPill } from 'components/accountPill/AccountPill'
import { Skeleton } from 'components/skeleton/Skeleton'

// Constants
import { FTM_EXPLORER_LINK, ETH_EXPLORER_LINK, FTM_EXPLORER_USDC, ETH_EXPLORER_WPOKT } from 'components/navbar/navbar.constants'

// Styles
import { AccountCountainer, Balance } from './currentAccount.styles'

// Utils
import { numberFormatter } from 'utils'

interface CurrentAccountProps {
  account: string
  isLoading: boolean
  currency?: string
  balance?: number
  chain:string
}

export const CurrentAccount = ({
  account,
  currency,
  balance = 0,
  isLoading,
  chain,
}: CurrentAccountProps): React.ReactElement => {
  const formattedBalance = useMemo(
    () =>
      numberFormatter({ number: balance, unit: currency, useGrouping: true }),
    [balance, currency]
  )

    let account_link = FTM_EXPLORER_LINK() + account
    let coin_acc_link = FTM_EXPLORER_USDC + account
    if (chain === "ethereum") {
        account_link = ETH_EXPLORER_LINK + account
        coin_acc_link = ETH_EXPLORER_WPOKT + account
    }

  return (
    <AccountCountainer>
      {currency && (
        <Balance  onClick={() => window.open(coin_acc_link, '_blank')?.focus()} >{isLoading ? <Skeleton /> : formattedBalance}</Balance>
      )}
      <AccountPill link={account_link.toString()} account={account} hiddeable />
    </AccountCountainer>
  )
}
